import { TEST_ALERT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'

export default endpoint => dispatch => dispatch(apiRequest(TEST_ALERT, { endpoint }))
